// @ts-nocheck
import PriceSpiderWhereToBuy, {
    PriceSpiderWhereToBuyStyles,
} from "@store/Library/Components/Foundation/PriceSpiderWhereToBuy";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { FC } from "react";
import { useSelector } from "react-redux";

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

interface PriceSpiderWhereToBuyWidgetStyles {
    extendedStyles?: PriceSpiderWhereToBuyStyles;
}

const priceSpiderWhereToBuyStyles: PriceSpiderWhereToBuyWidgetStyles = {};

const styles = priceSpiderWhereToBuyStyles;

const PriceSpiderWhereToBuyWidget: FC<Props> = () => {
    const { priceSpiderGenericKey, priceSpiderProductKey } = useSelector(
        (state: ApplicationState) => state.context.settings.settingsCollection.bunzlSettings!,
    );
    const currentPageType = useSelector((state: ApplicationState) => getCurrentPage(state)).type;
    const psType =
        currentPageType === "ProductDetailsPage" ? "Product" : "Generic";

    if (!psType) {
        return null;
    }

    if (psType === "Generic" && !priceSpiderGenericKey) {
        return null;
    }

    if (psType === "Product" && !priceSpiderProductKey) {
        return null;
    }

    return <PriceSpiderWhereToBuy type={psType} extendedStyles={styles.extendedStyles} />;
};

const widgetModule: WidgetModule = {
    component: PriceSpiderWhereToBuyWidget,
    definition: {
        displayName: "Price Spider - Where To Buy",
        group: "Common",
    },
};

export default widgetModule;
